export interface DailyIntakeInput {
  weightKg: number;
  ageYears: number;
  bodyCondition: "underweight" | "ideal" | "overweight";
  activityLevel: "low" | "medium" | "high";
}

export interface DailyIntakeResult {
  caloriesPerDay: number;
  gramsPerDay: number;
}

export function calculateDailyIntake(
  input: DailyIntakeInput
): DailyIntakeResult {
  const { weightKg, ageYears, bodyCondition, activityLevel } = input;

  const RER = 70 * Math.pow(weightKg, 0.75);

  let MER = RER;

  if (ageYears < 1) MER *= 2.0;
  if (activityLevel === "high") MER *= 1.2;
  if (activityLevel === "low") MER *= 0.9;

  if (bodyCondition === "overweight") MER *= 0.9;
  if (bodyCondition === "underweight") MER *= 1.05;

  const caloriesPerDay = Math.round(MER);

  // Your current recipes are ~1kcal per gram (slightly less)
  const gramsPerDay = Math.round(caloriesPerDay * 1.0);

  return {
    caloriesPerDay,
    gramsPerDay,
  };
}
